import * as React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import Checkbox from './Checkbox';
import ErrorMessage from '../ErrorMessage';

interface RegisteredCheckboxProps {
  children?: React.ReactNode;
  featureName?: string;
  id: string;
  errorMessage?: string;
  register: UseFormRegisterReturn;
  checked?: boolean;
  value?: string;
  containerStyle?: React.CSSProperties;
  boxStyle?: React.CSSProperties;
  labelBoxCellStyle?: React.CSSProperties;
  labelTextCellStyle?: React.CSSProperties;
  checkStyle?: React.CSSProperties;
}

const RegisteredCheckbox: React.FunctionComponent<RegisteredCheckboxProps> = ({
  children = null,
  errorMessage,
  id,
  register,
  featureName,
  checked = false,
  value,
  containerStyle = {},
  boxStyle = {},
  labelBoxCellStyle = {},
  labelTextCellStyle = {},
  checkStyle = {},
}) => {
  const errorId = `${id}-error`;
  const hasError = Boolean(errorMessage && errorMessage.length);
  const { onBlur: rOnBlur, onChange, ref, name } = register;

  const onBlur = React.useCallback(
    (event?: React.FocusEvent<HTMLInputElement>) => {
      if (event) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        rOnBlur(event);
      }
    },
    [rOnBlur],
  );

  return (
    <>
      <Checkbox
        onBlur={onBlur}
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onChange={onChange}
        ref={ref}
        name={name}
        featureName={featureName}
        error={hasError}
        ariaDescribedby={errorId}
        id={id}
        checked={checked}
        value={value}
        containerStyle={containerStyle}
        boxStyle={boxStyle}
        labelBoxCellStyle={labelBoxCellStyle}
        labelTextCellStyle={labelTextCellStyle}
        checkStyle={checkStyle}
      >
        {children}
      </Checkbox>
      <ErrorMessage id={errorId} featureName={featureName} show={hasError}>
        {errorMessage}
      </ErrorMessage>
    </>
  );
};

export default RegisteredCheckbox;
